import { render, staticRenderFns } from "./detailEdit.vue?vue&type=template&id=3dd62171&scoped=true&"
import script from "./detailEdit.vue?vue&type=script&lang=js&"
export * from "./detailEdit.vue?vue&type=script&lang=js&"
import style0 from "./detailEdit.vue?vue&type=style&index=0&id=3dd62171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd62171",
  null
  
)

export default component.exports